import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { LiveeventComponent } from './components/liveevent/liveevent.component';
import { LoggedInGuard } from './guards/loggedin.guard';

const routes: Routes = [
  { path: 'evento', component: LiveeventComponent, canActivate: [LoggedInGuard], },
  { path: '', redirectTo: 'evento', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
